import { render, staticRenderFns } from "./GrupoProceso.vue?vue&type=template&id=179ea208&scoped=true"
import script from "./GrupoProceso.vue?vue&type=script&lang=js"
export * from "./GrupoProceso.vue?vue&type=script&lang=js"
import style0 from "./GrupoProceso.vue?vue&type=style&index=0&id=179ea208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179ea208",
  null
  
)

export default component.exports